import { GET_COMMUNICATED, GET_COMMUNICATION, SYSTEM_TOAST_SUCCESS_MESSAGE, GET_TEMPLATES, GET_TEMPLATE, SYSTEM_TOAST_ERROR_MESSAGE } from './types';

import { serverEndPoint } from './Utils';
import axios from 'axios';

export const getCommunicated = () => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/communicated/getCommunicated`);
      if (status === 200) {
        let communicateds = data.map((c) => {
          let data = c.createdAt.substring(0, 10).split('-').reverse().join('-')
          c.createdAt = data
          return c
        })

        dispatch({
          type: GET_COMMUNICATED,
          payload: communicateds,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getCommunicationById = (_id) => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/communicated/getCommunicationById/${_id}`);
      if (status === 200) {
        await dispatch({
          type: GET_COMMUNICATION,
          payload: data[0],
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const deleteCommunicationById = (_id) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.delete(`${serverEndPoint}/communicated/deleteCommunicationById/${_id}`);
      if (status === 200) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Comunicado deletado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const createCommunication = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.post(`${serverEndPoint}/communicated/createCommunication`, params);
      if (status === 200) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Comunicado Adicionado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateCommunication = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.put(`${serverEndPoint}/communicated/updateCommunication`, params);
      if (status === 200) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Comunicado Alterado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const saveTemplate = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.post(`${serverEndPoint}/communicated/saveTemplate`, params);
      if (status === 200) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Modelo Salvo!',
        });
      }
    } catch (error) {
      dispatch({
        type: SYSTEM_TOAST_ERROR_MESSAGE,
        payload: 'Erro ao processar requisição',
      });
      console.log(error);
    }
  };
};

export const getEmailTemplates = () => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/communicated/getEmailTemplates`);
      if (status === 200) {
        dispatch({
          type: GET_TEMPLATES,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const getEmailTemplateById = (_id) => {
  return async (dispatch) => {
    try {
      const { data, status } = await axios.get(`${serverEndPoint}/communicated/getEmailTemplateById/${_id}`);
      if (status === 200) {
        dispatch({
          type: GET_TEMPLATE,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateTemplateById = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.put(`${serverEndPoint}/communicated/updateTemplateById`, params);
      if (status === 200) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'Modelo Salvo!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const sendCommunication = (params) => {
  return async (dispatch) => {
    try {
      const { status } = await axios.post(`${serverEndPoint}/communicated/sendCommunication`, params);
      if (status === 200) {
        dispatch({
          type: SYSTEM_TOAST_SUCCESS_MESSAGE,
          payload: 'E-mail enviado!',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};
